<div class="main-container" [dir]="dir">
    <mat-toolbar color="primary" class="topbar telative">
        <div class="navbar-header">
            <a class="navbar-brand" href="/">
                <!-- Logo icon -->
                <b>
              <img width="190" src="assets/images/logo/mycareplan.png" alt="homepage" class="light-logo">
          </b>
                <!--End Logo icon -->
                <!-- Logo text -->
                <!-- <span fxShow="false" fxShow.gt-xs> -->
              <!-- dark Logo text -->
              <!-- <img src="assets/images/logo-text.png" alt="homepage" class="dark-logo"> -->
              <!-- Light Logo text -->
              <!-- <img src="assets/images/logo/mycareplan.png" class="light-logo" alt="homepage">
          </span> -->
            </a>
        </div>

        <button mat-icon-button (click)="snav.toggle()" value="sidebarclosed">
      <mat-icon>menu</mat-icon>
    </button>
    <div fxFlex="25">
        <app-advance-search *ngIf="boardName" [board]="boardName"></app-advance-search>
    </div>
    <!-- <button mat-icon-button class="srh-btn" (click)="onSearchBtnClick('start')">
      <mat-icon>search</mat-icon>
    </button>
    <form class="card-search">
        <app-search (closeBtnClick)="onCloseSearch($event)"></app-search>
    </form>
    <form class="full-search">
        <input type="text" class="form-control" placeholder="Search &amp; enter">
        <a class="cl-srh-btn" (click)="onSearchBtnClick('stop')">
            <i class="ti-close"></i>
        </a>
    </form> -->
        <span fxFlex></span>
        <button mat-icon-button (click)="logout()">
        <mat-icon>logout</mat-icon>
    </button>

    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="accent" *ngIf="isShow"></mat-progress-bar>

    <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">

        <mat-sidenav #snav id="snav" class="pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0" [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches" (open)="sidebarOpened = true" (close)="sidebarOpened = false" [perfectScrollbar]="config">

            <app-sidebar class="app-sidebar"></app-sidebar>

        </mat-sidenav>

        <mat-sidenav-content id="page-wrapper" class="page-wrapper">

            <div class="page-content">

                <router-outlet>
                    <!-- <app-spinner></app-spinner> -->
                </router-outlet>

            </div>

        </mat-sidenav-content>

    </mat-sidenav-container>
</div>